import(/* webpackMode: "eager" */ "/app/src/app/operator/page.tsx");
